import React from 'react'

const machuPichu = {
    id: 'planning-machu-picchu',
    type: 'post',
    countryId: 'peru',
    title: 'Planning Our Trip to Machu Picchu',
    longDate: 'June 2, 2018',
    month: 'June',
    date: '2',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/CoverMachuPicchu.jpg',
    coverImagePosition: 'top',
    content: [
        {
            text: (
                <div>My mom had two bucket list travel destinations in life: New Zealand and Machu Picchu. After a trip to the land of the Kiwis recently, she and my sister Merilee decided to tackle Peru, and I invited myself and Peter. And then I enlisted myself as our trip planner.</div>
            )
        },
        {
            text: (
                <div>In researching the trip, I found tons of blog posts showing pictures from the ruins and TripAdvisor forums on various logistical topics, but it was still difficult to plan step by step getting from Lima to Machu Picchu. So, I've put together some information on what you need to know if you plan your own trip. Please <a href="mailto:alicecamilleavery@gmail.com">let me know</a> if you decide to go and want more details!</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/AliceMPWalls.jpg',
        },
        {
            header: 'Getting Started'
        },
        {
            text: (
                <div>You'll need to buy Machu Picchu tickets months in advance. The most popular time to go is June/July, which is the only time you can see the sunrise at Machu Picchu. April was perfect – it's just after the rainy season ends so everything is very green, but not crazy crowded. We booked through a TripAdvisor company, Viator, and bought our tickets through TripAdvisor.</div>
            )
        },
        {
            header: 'Getting There'
        },
        {
            text: (
                <div>You'll need to acclimate to the altitude before going to the ruins. It's a good idea to stay in Cusco for 2 days. We did 1.5 days, and my mom had a pretty hard time with it. Peter got sick, but we think that was actually from multiple Pisco sours followed by a morning workout.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/MachuPicchu.jpg',
        },
        {
            text: (
                <div>Cusco is at 11,000 feet and Machu Picchu is 8,000, so as you travel through the Sacred Valley you can use that time to acclimate more. We took 9 days total with days 1 and 9 being our international flights in and out of Lima, and this was the shortest trip I'd recommend. Better to go for two weeks so you can slow down and add some other spots in Peru!</div>
            )
        },
        {
            text: (
                <div>Our itinerary was:
                    <ul>
                        <li>Day 1: Arrive in Lima in the evening. After a delayed flight, we got in pretty late and had to get back to the airport in the morning to get to Cusco, so the decision to stay in the trendy Miraflores neighborhood meant we paid more and spent more time in a taxi going to and from the airport. If you have a quick turnaround to Cusco, I'd recommend finding a hotel close to the airport.</li>
                        <li>Day 2: Fly to Cusco mid-day</li>
                        <li>Day 3: Cusco</li>
                        <li>Day 4: Drive from Cusco to Ollantaytambo (Sacred Valley tour)</li>
                        <li>Day 5: Ollantaytambo</li>
                        <li>Day 6: Train out and back to Machu Picchu</li>
                        <li>Day 7: Late morning taxi back to Cusco (~2 hours)</li>
                        <li>Day 8: Fly back to Lima (4 hour delay = limited time in Lima)</li>
                        <li>Day 9: Flight home</li>
                    </ul>
                </div>
            )
        },
        {
            text: (
                <div>After spending some time in Cusco, we headed to Ollantaytambo where we'd catch the train to Machu Picchu. I'm so glad we decided to slow down a bit here and spend three nights at the same hotel. I highly recommend staying in Ollantaytambo before and after the train to Machu Picchu – most people immediately get a taxi after getting off in the evening for the 2 hour drive back to Cusco, and that's pretty brutal.</div>
            )
        },
        {
            text: (
                <div>I also recommend getting a tour guide for 1-2 days at beginning of trip, particularly to see Sacred Valley spots which are only accessible by car. We got a recommendation for an independent guide, Laura Ramos, who was amazing. I'd be happy to pass on her email to anyone looking for a guide! We learned so much about the ancient Peruvian civilization, the Incan rulers, and their religion, and it was really helpful going into Machu Picchu.</div>
            )
        },

        {
            text: (
                <div>In addition to entrance tickets to Machu Picchu, you'll need to book the train to Aguas Calientes (the station at the base of the mountain) early – like months early. The main companies are Peru Rail and Inka Rail. We bought the basic Explorer tickets from Peru Rail and it was great.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/Train.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/AguasCalientes.jpg',
            detailText: 'Aguas Calientes is small and charming.'
        },
        {
            text: (
                <div>Once you get into Aguas Calientes, you'll need to take a bus (~$25) up to the actual ruins and back (DON'T WALK!! It would take hours and looks exhausting.) You don't need to book this ahead of time - you'll see the bus station at the bottom of the river in the middle of town and you can buy tickets valid for any bus, any time.</div>
            )
        },
        {
            text: (
                <div>We took a 6:10 a.m. train from Ollantaytambo to M.P. and our entry to the ruins was at 10 a.m.; this was too much time. Luckily, we figured out that you can actually enter earlier than that, or at least since there weren't too many people in April it was fine for us to go in half an hour early. Alternately, you could train in the night before to get into the ruins early in the morning, beating the rush. However, you can only take 1 tiny carry-on (a small backpack) on the train with you, so you'd need to leave your luggage at a hotel in Cusco or Ollantaytambo and take not much more than 1 change of clothes with you.</div>
            )
        },
        {
            header: 'At Machu Picchu'
        },
        {
            text: (
                <div>You know the big peak that rises above the ruins in every photo of Machu Picchu? It's called Huyana Picchu, and you can walk to the top – which I highly recommend! It was the toughest hike we'd ever done (until we did Laugavegur and Tour du Mont Blanc a few months later… #growth.) It is also very warm and steamy and kind of smells like the alligator enclosure at the zoo. But! Totally worth it for the endorphins and the view.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/Vertical.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/HuyanaPicchuView.jpg'
        },
        {
            text: (
                <div>You buy a combined ticket for Machu Picchu and Huyana Picchu and have a choice of either 7 a.m. or 10 a.m. entry. The start of the Huyana Picchu hike is at the far end of the ruins, and it takes about 10-15 minutes to walk there from the main entrance. So if you buy a combined ticket for 10 a.m. entry to Huyana Picchu, go to Machu Picchu earlier than that and give yourself time to wander before queueing up.</div>
            )
        },
        {
            text: (
                <div>When you enter, hike the small peak on the left, Huchu Ypicchu, first – almost no one does, it only takes 20 minutes, and you get much a better view of the ruins. We had it entirely to ourselves and got the epic photo of Peter at the top of this post there.</div>
            )
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/HuchuYpicchuSign.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/HYhike.jpg']
        },
        {
            text: (
                <div>Here's the MOST IMPORTANT thing we learned!: Machu Picchu is tracked into four one-way paths and you are strictly forbidden from getting off the paths or going in a different direction. You can't just freely wander. So once you start on one path, you have to complete it and go out the exit, and then you get 1 re-entry per person. So don't rush through any part of it to get to a specific site; you won't be able to go back.</div>
            )
        },
        {
            header: 'The Details: Transportation, Money, and Medicine'
        },
        {
            text: (
                <div>There's a cheap green taxi stand at the Lima and Cusco airports. Getting from Lima airport to Miraflores should cost $20 – when you head back out at the end of your trip, have your hotel book for you but insist on no more than $20 (hotels may try to charge you twice as much to get back to the airport, so they can take a cut.)</div>
            )
        },
        {
            text: (
                <div>Everything is negotiable (outside of restaurants, grocery stores, and entry tickets) – but the people there are the nicest about bartering that I've ever encountered. The price quoted to you for taxis and souvenirs is inflated and they expect you to counter with a lower price. Don't be afraid!</div>
            )
        },
        {
            text: (
                <div>The flight path into Cusco is tricky and surrounded by mountains, so delays are common when there's low visibility. Build extra time into your schedule.</div>
            )
        },
        {
            text: (
                <div>You'll need a doctor's prescription for altitude sickness pills; don't put off your appointment. You're supposed to start taking the pills 24 hours before you enter altitude and continue 2 days after leaving altitude. Bring bug spray for Machu Picchu, but there's no malaria risk. Lastly, bring Immodium for unexpected stomach issues (this applies every time you travel!)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/MachuPicchu/Llama.jpg',
            detailText: 'Bye, llamas of Machu Picchu!'
        }
    ]
}

export default machuPichu


// WEBPACK FOOTER //
// ./src/Posts/Content/MachuPichu.js